import { useParams, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';

import axios from 'axios';
import { API_URL } from '../apiUrl';


const hoyoServers = [
    { value: '', label: 'Pilih Server' },
    { value: 'Asia', label: 'Asia' },
    { value: 'America', label: 'America' },
    { value: 'Europe', label: 'Europe' },
    { value: 'TK, HK, MO', label: 'TK, HK, MO' }
];

const idLabels = {
    'Mobile Legends: Bang Bang': { id: 'User ID', server: 'Zone ID' },
    'Genshin Impact': { id: 'UID', server: 'Server', options: hoyoServers },
    'Honkai: Star Rail': { id: 'UID', server: 'Server', options: hoyoServers },
    'Zenless Zone Zero': { id: 'UID', server: 'Server', options: hoyoServers },
    'Honkai Impact 3rd': { id: 'UID', server: 'Server', options: hoyoServers },
    'Garena Free Fire': { id: 'Player ID', server: null },
    'Valorant': { id: 'Riot ID', server: 'Tagline' },
    'PUBG Mobile': { id: 'Player ID', server: null },
};

const formatPrice = (price) => {
    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(price);
};

const GameDetailPage = () => {
    const { gameName } = useParams();
    const decodedName = decodeURIComponent(gameName);
    const navigate = useNavigate();



    const [products, setProducts] = useState([]);
    const [category, setCategory] = useState(null);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [userId, setUserId] = useState('');
    const [serverId, setServerId] = useState('');
    const [loading, setLoading] = useState(true);
    // const [nickname, setNickname] = useState('');
    // const [errorNickname, setErrorNickname] = useState('');
    // const [isChecking, setIsChecking] = useState(false);
    const [saveId, setSaveId] = useState(false);

    const labels = idLabels[decodedName] || { id: 'User ID', server: null };

    useEffect(() => {
        // Cek dan muat ID tersimpan dari LocalStorage khusus untuk game ini
        const savedData = localStorage.getItem(`saved_id_${decodedName}`);
        if (savedData) {
            try {
                const parsed = JSON.parse(savedData);
                if (parsed.userId) setUserId(parsed.userId);
                if (parsed.serverId) setServerId(parsed.serverId);
                setSaveId(true);
            } catch (e) {
                console.error("Gagal format saved ID", e);
            }
        }

        const fetchData = async () => {
            setLoading(true);
            try {
                // Fetch products and category details in parallel
                const [productRes, categoryRes] = await Promise.all([
                    axios.get(`${API_URL}/product/category/${encodeURIComponent(decodedName)}`),
                    axios.get(`${API_URL}/category/${encodeURIComponent(decodedName)}`)
                ]);
                const allProducts = productRes.data.sort((a, b) => a.price - b.price);
                setProducts(allProducts);
                setCategory(categoryRes.data);
            } catch (err) {
                console.error('Error fetching game data:', err);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, [decodedName]);


    /*
    const handleCheckNickname = async () => {
        if (!userId.trim()) {
            alert(`Masukkan ${labels.id} terlebih dahulu!`);
            return;
        }
        if (labels.server && !serverId.trim()) {
            alert(`Masukkan ${labels.server} terlebih dahulu!`);
            return;
        }

        setIsChecking(true);
        setNickname('');
        setErrorNickname('');

        try {
            const response = await axios.post(`${API_URL}/api/check-nickname`, {
                game: decodedName,
                target: userId,
                zone: serverId
            });

            if (response.data.result) {
                setNickname(response.data.data);
            } else {
                setErrorNickname(response.data.message || 'ID tidak ditemukan atau sistem sedang sibuk.');
            }
        } catch (err) {
            console.error("Check nickname error:", err);
            setErrorNickname("Sistem pengecekan sedang gangguan, silakan lanjut jika yakin ID benar.");
        } finally {
            setIsChecking(false);
        }
    };
    */

    const handleBuy = () => {

        if (!selectedProduct) {
            alert('Pilih nominal terlebih dahulu!');
            return;
        }
        if (!userId.trim()) {
            alert(`Masukkan ${labels.id} terlebih dahulu!`);
            return;
        }
        if (labels.server && !serverId.trim()) {
            alert(`Masukkan ${labels.server} terlebih dahulu!`);
            return;
        }

        if (saveId) {
            localStorage.setItem(`saved_id_${decodedName}`, JSON.stringify({ userId, serverId: serverId || null }));
        } else {
            localStorage.removeItem(`saved_id_${decodedName}`);
        }

        const orderData = {
            game: decodedName,
            product: selectedProduct,
            userId: userId,
            serverId: serverId || null,
        };

        navigate('/checkout', { state: orderData });
    };

    return (
        <div id="gamedetailpage">
            {/* Hero Banner */}
            <div className="game-hero" style={{ backgroundImage: `url(${category?.banner || '/images/hero_ml.png'})` }}>
                <div className="game-hero-overlay">
                    <div className="container">
                        <div className="game-hero-content">
                            {category && (
                                <img
                                    src={category.image}
                                    alt={decodedName}
                                    className="game-hero-icon"
                                />
                            )}
                            <div>
                                <h1 className="game-hero-title">{decodedName}</h1>
                                <p className="game-hero-subtitle">Top Up Cepat, Aman & Terpercaya</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container my-4">
                <div className="row">
                    {/* Left Column: ID Form */}
                    <div className="col-lg-4 mb-4">
                        <div className="game-id-card">
                            <h5 className="game-id-title">
                                <i className="bi bi-person-badge me-2"></i>
                                Masukkan Data Akun
                            </h5>
                            <div className="mb-3">
                                <label className="form-label game-label">{labels.id}</label>
                                <input
                                    type="text"
                                    className="form-control game-input"
                                    placeholder={`Masukkan ${labels.id}`}
                                    value={userId}
                                    onChange={(e) => setUserId(e.target.value)}
                                />
                            </div>
                            {labels.server && (
                                <div className="mb-3">
                                    <label className="form-label game-label">{labels.server}</label>
                                    {labels.options ? (
                                        <select
                                            className="form-select game-input"
                                            value={serverId}
                                            onChange={(e) => setServerId(e.target.value)}
                                        >
                                            {labels.options.map((opt, i) => (
                                                <option key={i} value={opt.value} disabled={opt.value === ''}>
                                                    {opt.label}
                                                </option>
                                            ))}
                                        </select>
                                    ) : (
                                        <input
                                            type="text"
                                            className="form-control game-input"
                                            placeholder={`Masukkan ${labels.server}`}
                                            value={serverId}
                                            onChange={(e) => setServerId(e.target.value)}
                                        />
                                    )}
                                </div>
                            )}
                            <div className="game-id-note mb-3">
                                <i className="bi bi-info-circle me-1"></i>
                                Pastikan ID dan data akun yang kamu masukkan sudah benar.
                            </div>

                            <div className="form-check mt-3">
                                <input 
                                    className="form-check-input" 
                                    type="checkbox" 
                                    id="saveIdCheck" 
                                    checked={saveId}
                                    onChange={(e) => setSaveId(e.target.checked)}
                                    style={{ cursor: 'pointer' }}
                                />
                                <label className="form-check-label text-muted small" htmlFor="saveIdCheck" style={{ cursor: 'pointer' }}>
                                    Simpan ID untuk pembelian berikutnya
                                </label>
                            </div>

                            {/* {/* Fitur Cek Nickname disembunyikan sementara */}
                        </div>
                    </div>

                    {/* Right Column: Product Grid */}
                    <div className="col-lg-8">
                        <h5 className="product-section-title">
                            <i className="bi bi-cart3 me-2"></i>
                            Pilih Nominal
                        </h5>
                        {loading ? (
                            <div className="text-center py-5">
                                <div className="spinner-border text-success" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        ) : (
                            <div className="row">
                                {products.filter(p => p.available !== false).map((p) => (
                                    <div key={p.id} className="col-6 col-md-4 col-lg-3 mb-3">
                                        <div
                                            className={`product-card ${selectedProduct && selectedProduct.id === p.id ? 'product-card-selected' : ''}`}
                                            onClick={() => setSelectedProduct(p)}
                                        >
                                            <div className="product-card-icon">
                                                <i className="bi bi-gem"></i>
                                            </div>
                                            <div className="product-card-name">{p.brand}</div>
                                            <div className="product-card-price">{formatPrice(p.price)}</div>
                                            {selectedProduct && selectedProduct.id === p.id && (
                                                <div className="product-card-check">
                                                    <i className="bi bi-check-circle-fill"></i>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                ))}
                                {products.filter(p => p.available === false).map((p) => (
                                    <div key={p.id} className="col-6 col-md-4 col-lg-3 mb-3">
                                        <div className="product-card product-card-unavailable">
                                            <div className="product-card-icon">
                                                <i className="bi bi-gem"></i>
                                            </div>
                                            <div className="product-card-name">{p.brand}</div>
                                            <div className="product-unavailable-badge">Tidak Tersedia</div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}

                        {/* Buy Button */}
                        <div className="buy-section">
                            <div className="buy-summary">
                                {selectedProduct ? (
                                    <>
                                        <span className="buy-item">{selectedProduct.brand}</span>
                                        <span className="buy-price">{formatPrice(selectedProduct.price)}</span>
                                    </>
                                ) : (
                                    <span className="buy-item text-muted">Belum ada item dipilih</span>
                                )}
                            </div>
                            <button
                                className="buy-btn"
                                onClick={handleBuy}
                                disabled={!selectedProduct}
                            >
                                <i className="bi bi-bag-check me-2"></i>
                                Beli Sekarang
                            </button>
                        </div>
                    </div>
                </div>

                {/* Review Section */}
                <div className="row mt-5">
                    <div className="col-12">
                        <ReviewSection gameName={decodedName} />
                    </div>
                </div>
            </div>
        </div>
    );
};

const ReviewSection = ({ gameName }) => {
    const [summary, setSummary] = useState({ avgRating: 0, totalReviews: 0, star5: 0, star4: 0, star3: 0, star2: 0, star1: 0 });
    const [reviews, setReviews] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const [sumRes, revRes] = await Promise.all([
                    axios.get(`${API_URL}/api/reviews/summary/${encodeURIComponent(gameName)}`),
                    axios.get(`${API_URL}/api/reviews/${encodeURIComponent(gameName)}`)
                ]);
                setSummary(sumRes.data);
                setReviews(revRes.data);
            } catch (err) {
                console.error("Fetch reviews error:", err);
            } finally {
                setLoading(false);
            }
        };
        fetchReviews();
    }, [gameName]);

    const formatDateShort = (dateStr) => {
        const date = new Date(dateStr);
        return date.toLocaleString('id-ID', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit'
        }).replace(/\//g, '-');
    };

    if (loading) return null;

    return (
        <div className="review-section-container">
            <h5 className="fw-bold mb-4">Penilaian dan Review</h5>
            <div className="row g-4">
                {/* Score Summary */}
                <div className="col-lg-5">
                    <div className="review-summary-header">
                        <span className="big-rating-number">{(summary.avgRating || 0).toFixed(1)}</span>
                        <span className="rating-out-of">/ 5.0</span>
                    </div>

                    <div className="star-distribution">
                        {[5, 4, 3, 2, 1].map(star => {
                            const count = summary[`star${star}`] || 0;
                            const percent = summary.totalReviews > 0 ? (count / summary.totalReviews) * 100 : 0;
                            return (
                                <div className="star-row" key={star}>
                                    <div className="star-label">{star} <i className="bi bi-star-fill text-warning"></i></div>
                                    <div className="rating-progress-bg">
                                        <div className="rating-progress-fill" style={{ width: `${percent}%` }}></div>
                                    </div>
                                    <div className="star-count-text">{count}</div>
                                </div>
                            );
                        })}
                    </div>
                </div>

                {/* Review List */}
                <div className="col-lg-7">
                    <div className="reviews-list-scroll">
                        {reviews.length === 0 ? (
                            <div className="text-center py-5 text-muted">
                                <i className="bi bi-chat-dots fs-1 d-block mb-3"></i>
                                <p>Belum ada review untuk game ini.</p>
                            </div>
                        ) : (
                            reviews.map((rev) => (
                                <div className="review-item-card" key={rev._id}>
                                    <div className="review-item-header">
                                        <span className="reviewer-id">{rev.userDisplay}</span>
                                        <div className="review-stars-static">
                                            {[...Array(5)].map((_, i) => (
                                                <i key={i} className={`bi ${i < rev.rating ? 'bi-star-fill' : 'bi-star'}`}></i>
                                            ))}
                                        </div>
                                    </div>
                                    <span className="review-product-badge">{rev.productName}</span>
                                    <div className="review-comment-text">"{rev.comment || 'mantap'}"</div>
                                    <div className="review-date-small">{formatDateShort(rev.createdAt)}</div>
                                </div>
                            ))
                        )}
                    </div>
                    
                    {reviews.length > 0 && (
                        <button className="buy-btn w-100 mt-4" style={{ height: '45px' }}>
                            Lihat selengkapnya
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default GameDetailPage;
